export default "__VITE_ASSET__DMjuiaKI__"